import { Grid } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { GridItem } from '../GridItem';
import { TagsDisplay } from '../EntityChips';

export interface EntityTagsProps {
  entity: Entity;
}

export const EntityTags: React.FC<EntityTagsProps> = ({ entity }) => {
  if (!entity.metadata.tags || entity.metadata.tags.length === 0) {
    return null;
  }

  return (
    <Grid container>
      <GridItem
        label="Tags"
        value={<TagsDisplay tags={entity.metadata.tags} />}
        gridSizes={{ xs: 12 }}
      />
    </Grid>
  );
};
